import { types } from 'mobx-state-tree'
import CommonFileModel from '../common/FileModel'

const NewsFileModel = CommonFileModel.named('NewsFileModel').props({
  newsId: types.optional(types.number, 0),
})

export default NewsFileModel
